// extracted by mini-css-extract-plugin
export var copyableItem = "_51-0";
export var underlined = "_51-1";